import {
  DEMO_COMMANDES_BOUTIQUE,
  DEMO_OEUVRES_BOUTIQUE,
  DEMO_REGLAGES_BOUTIQUE,
} from './demoFixtures.js';
import type { CorpsReglagesBoutique } from './boutique.js';
let commandes = structuredClone(DEMO_COMMANDES_BOUTIQUE);
let oeuvres = structuredClone(DEMO_OEUVRES_BOUTIQUE);
let reglages = structuredClone(DEMO_REGLAGES_BOUTIQUE);
export function reinitialiserBoutiqueDemo() {
  commandes = structuredClone(DEMO_COMMANDES_BOUTIQUE);
  oeuvres = structuredClone(DEMO_OEUVRES_BOUTIQUE);
  reglages = structuredClone(DEMO_REGLAGES_BOUTIQUE);
}
export function reponseBoutiqueDemo(
  chemin: string,
  params: URLSearchParams,
  methode: string,
  corps?: unknown,
): unknown | undefined {
  const paginer = <T>(items: T[]) => {
    const page = Number(params.get('page') ?? 1),
      parPage = Number(params.get('parPage') ?? 30);
    return {
      items: items.slice((page - 1) * parPage, page * parPage),
      pagination: {
        page,
        parPage,
        total: items.length,
        pages: Math.max(1, Math.ceil(items.length / parPage)),
      },
    };
  };
  if (chemin === '/boutique/reglages') {
    if (methode === 'PUT') {
      const c = corps as CorpsReglagesBoutique;
      const change =
        c.conditionsVente &&
        JSON.stringify(c.conditionsVente) !== JSON.stringify(reglages.conditionsVente);
      reglages = { ...reglages, ...c };
      if (change || !reglages.conditionsValidees)
        reglages = {
          ...reglages,
          ouverte: false,
          conditionsValidees: false,
          conditionsValideesLe: null,
        };
      else if (c.conditionsValidees) reglages.conditionsValideesLe = new Date().toISOString();
    }
    return { reglages: structuredClone(reglages) };
  }
  if (chemin === '/boutique/oeuvres' && methode === 'GET') {
    const r = paginer(
      oeuvres.filter(
        (o) =>
          `${o.titre} ${o.artisteNom}`
            .toLowerCase()
            .includes((params.get('q') ?? '').toLowerCase()) &&
          (!params.get('enVente') || o.enVente === (params.get('enVente') === 'true')),
      ),
    );
    return { oeuvres: structuredClone(r.items), pagination: r.pagination };
  }
  const oeuvre = /^\/boutique\/oeuvres\/([^/]+)$/.exec(chemin);
  if (oeuvre && methode === 'PUT') {
    const o = oeuvres.find((o) => o.id === oeuvre[1]);
    if (!o) return undefined;
    const enVente = (corps as { enVente: boolean }).enVente;
    if (!enVente || !o.raison) o.enVente = enVente;
    return structuredClone(o);
  }
  if (chemin === '/boutique/commandes' && methode === 'GET') {
    const r = paginer(
      commandes.filter((c) => !params.get('etat') || c.etat === params.get('etat')),
    );
    return { commandes: structuredClone(r.items), pagination: r.pagination };
  }
  const commande = /^\/boutique\/commandes\/([^/]+)(\/rembourser)?$/.exec(chemin);
  if (commande) {
    const c = commandes.find((c) => c.id === commande[1]);
    if (!c) return undefined;
    if (
      commande[2] &&
      methode === 'POST' &&
      c.facture &&
      ['payee', 'a_rembourser'].includes(c.etat)
    ) {
      c.etat = 'remboursee';
      c.motif = 'remboursement_demande';
      c.avoir = { id: 'avoir-boutique-demo', numero: 'A-2026-0007' };
    }
    return structuredClone(c);
  }
  return undefined;
}
